module.exports = __webpack_public_path__ + "static/media/cosmetics-dept-reinvention.96413176.png";